<button type="button" 
    [ngClass]="{'toyota-btn-round': buttonConfig['type'] === 'primary',
     'toyota-btn-round-secondary' :buttonConfig['type'] === 'secondary' }" 
    [class.toyota-btn-sm] = "buttonConfig['size'] === 'sm'">
    {{ buttonConfig.text}}
</button>
